import { createContext } from "react";

interface IAuthContext {
  token: string;
  email: string;
  refreshToken: string;
  expirationTime: string;
  groups: string[];
  login: Function;
}

const AuthContext = createContext<IAuthContext>({
  token: "",
  email: "",
  refreshToken: "",
  expirationTime: "",
  groups: [],
  login: () => null,
});

export default AuthContext;
